export default "__VITE_ASSET__DvtbVuSA__"